import { Button, MenuItem, Grid, TextField } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";

import Dialog from "../../dialog";
import Snackbar from "../../snackbar";
import { textFieldStyles } from "./styles";
import SelectMenu from "./selectMenu";
import DescriptionComponent from "../../descriptionComponent";
import InputFileReader from "../../fileReader";
import InputFormat from "../../../partials/inputForm";
import Loading from "../../loading";
class EditMenuItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      disabled: 0,
      data: {
        name: "",
        code: "",
        featured: 0,
        parentCode: "",
        description: "",
        image: "",
      },
    };
  }
  componentDidMount() {
    this.props.onRef(this);
    let _this = this;
    this.setState({ data: Object.assign(this.props.data) }, function () {
      _this.DescriptionComponent.changeDescription(
        this.props.data.description || ""
      );
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.data !== nextProps.data) {
      let _this = this;
      this.setState({ data: Object.assign(nextProps.data) }, function () {
        _this.DescriptionComponent.changeDescription(
          nextProps.data.description || ""
        );
      });
    }
  }

  resetValue = () => {
    this.setState({
      data: {
        name: "",
        code: "",
        featured: 0,
        parentCode: "",
        description: "",
        image: "",
      },
    });
  };
  deleteGroup = async () => {
    const { t } = this.props;
    const { data } = this.state;
    this.loading.startLoading();
    this.mDialogDelete.handleDialogClose();
    let check = await this.props.deleteMenuGroup({ menuId: data.id });
    this.loading.stopLoading();
    this.props.finishAction(
      check.code === 1 ? check.code : check.message,
      "delete"
    );
  };

  handleChange = (e) => {
    var name = e.target.name;
    var value = e.target.value;
    var data = this.state.data;
    if (e.target.type === "checkbox") {
      data[name] = value ? 1 : 0;
      this.setState({ data }, function () {});
    } else {
      if (name == "featured" && value == -1) value = 0;
      data[name] = value;
      this.setState({ data }, function () {});
    }
  };

  handleSelectSuportChange = (value) => {
    var data = this.state.data;
    data.support = value;
    this.setState({ data }, function () {});
  };

  handleSubComponentChange = (name, value) => {
    var data = this.state.data;
    data[name] = value;
    this.setState({ data });
  };

  onChange = (value) => {
    // eslint-disable-line
    var data = this.state.data;
    data.isActive = value ? 1 : 0;
    this.setState({ data });
  };

  handleSubmit = async () => {
    const { t, type, serviceSetting } = this.props;
    let check;
    // this.mDialog.handleDialogClose();
    this.loading.startLoading();
    let parentCode = this.selectMenu.getData();

    if (type === "edit") {
      let data = {
        ...this.state.data,
        featured: this.state.data.featured || 0,
      };
      if (this.InputFileReader.getFile() !== null) {
        let checkUpload = await this.props.uploadDispatch.saveStorage({
          files: this.InputFileReader.getFile(),
          imgPre: data.image,
          code: this.props.serviceCode,
          type: "img-menu",
        });
        if (checkUpload.code === 1) {
          data.image = checkUpload.data.previewLink;
        }
      } else if (this.InputFileReader.getSrc() !== null) {
        data.image = this.InputFileReader.getSrc();
      } else if (this.InputFileReader.getFile() === null) {
        if (data.image && this.InputFileReader.getFlagEdit()) {
          data.image = "";
        }
      }
      check = await this.props.editMenuGroup(
        Object.assign(data, { parentCode: parentCode })
      );
    } else {
      let data = {
        code:
          this.state.data.code ||
          `${serviceSetting.prefixMenu}${serviceSetting.totalMenu + 1}`,
        name: this.state.data.name,
        featured: this.state.data.featured || 0,
        description: this.state.data.description || "",
        parentCode: parentCode,
      };
      if (this.InputFileReader.getFile() !== null) {
        let checkUpload = await this.props.uploadDispatch.saveStorage({
          files: this.InputFileReader.getFile(),
          code: this.props.serviceCode,
          type: "img-menu",
        });
        if (checkUpload.code === 1) {
          data.image = checkUpload.data.previewLink;
        }
      } else if (this.InputFileReader.getSrc() !== null) {
        data.image = this.InputFileReader.getSrc();
      }
      check = await this.props.addMenuGroup(data);
    }
    this.loading.stopLoading();
    this.props.finishAction(
      check.code === 1 ? check.code : check.message,
      type
    );
  };
  handleCheck = (type) => {
    let { t } = this.props;
    const { data = {} } = this.props;
    if (!data.name) {
      this.mSnackbarInEdit.handleClick(
        t("menu_menugroup_addmenugroup_please_fill_in_name")
      );
    } else {
      type === "delete"
        ? this.mDialogDelete.handleDialogOpen()
        : this.handleSubmit();
    }
  };
  render() {
    const {
      classes,
      t,
      role,
      ownerCode,
      type,
      serviceSetting,
      handleCancel,
    } = this.props;
    const { data } = this.state;
    return (
      <form className={classes.container} noValidate autoComplete="off">
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbarInEdit = snackbar)}
          test="inEdit"
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <Dialog
          onRef={(dialog) => (this.mDialogDelete = dialog)}
          disagree={t("menu_menugroup_cancel")}
          agree={t("menu_menugroup_yes")}
          title={t("menu_menugroup_confirm")}
          content={t("menu_menugroup_do_you_want_to_delete_this_menu_group")}
          action={this.deleteGroup}
        />
        {/* <Dialog
          onRef={dialog => (this.mDialog = dialog)}
          disagree={type == 'edit' ? t("menu_menugroup_editmenugroup_cancel") : t("menu_menugroup_addmenugroup_cancel")}
          agree={type == 'edit' ? t("menu_menugroup_editmenugroup_yes") : t("menu_menugroup_addmenugroup_yes")}
          title={type == 'edit' ? t("menu_menugroup_editmenugroup_confirm") : t("menu_menugroup_addmenugroup_confirm")}
          content={type == 'edit' ? t("menu_menugroup_editmenugroup_do_you_want_to_change_name_of_this_menu_group") : t("menu_menugroup_addmenugroup_add_new_menu_group")}
          action={this.handleSubmit}
        /> */}
        <Grid container spacing={3} alignItems="center">
          {/* <Grid item xs={12} sm={6} md={6} lg={6}  >
            <InputFormat
              required
              label='Code'
              name="code"
              fullWidth={true}
              value={data.code || `${serviceSetting.prefixMenu}${serviceSetting.totalMenu + 1}`}
              onChange={this.handleChange}

            />
          </Grid> */}
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <InputFormat
              select
              label={t("menu_menugroup_editmenugroup_featured")}
              placeholder={t("pls_select")}
              fullWidth={true}
              value={data.featured || -1}
              onChange={this.handleChange}
              name="featured"
            >
              <MenuItem value={1}>
                {t("menu_menugroup_editmenugroup_featured")}
              </MenuItem>
              <MenuItem value={-1}>
                {t("menu_menugroup_editmenugroup_not_featured")}
              </MenuItem>
            </InputFormat>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <SelectMenu
              onRef={(id) => (this.selectMenu = id)}
              data={data}
              menuId={data.parentCode || ""}
              id={data.id}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <InputFormat
              required
              multiline
              label={t("menu_menugroup_editmenugroup_name")}
              fullWidth={true}
              name="name"
              value={data.name || ""}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <DescriptionComponent
              onRef={(id) => (this.DescriptionComponent = id)}
              title={t("menu_menuitem_editmenuitem_description")}
              handleSubComponentChange={this.handleSubComponentChange}
              description={data.description}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <InputFileReader
              container="square"
              onRef={(id) => (this.InputFileReader = id)}
              style={classes}
              defaultImg={data.image || "/images/noneImage.svg"}
              selectStorageMode={true}
            />
          </Grid>
          {type === "edit" && (
            <Grid item xs={12} sm={12} md={12} className={classes.flexEnd}>
              {handleCancel && (
                <Button
                  disabled={role === "admin" && ownerCode}
                  onClick={handleCancel}
                  color="primary"
                  variant="outlined"
                  className={classes.button}
                >
                  {t("cancel")}
                </Button>
              )}

              <Button
                disabled={role === "admin" && ownerCode}
                onClick={() => this.handleCheck("delete")}
                color="secondary"
                variant="contained"
                className={classes.button}
              >
                {t("menu_menugroup_delete")}
              </Button>
              <Button
                disabled={role === "admin" && ownerCode}
                onClick={() => this.handleCheck("edit")}
                color="primary"
                variant="contained"
                className={classes.button}
              >
                {t("menu_menugroup_editmenugroup_save")}
              </Button>
            </Grid>
          )}
          {type === "add" && (
            <Grid item xs={12} sm={12} md={12} className={classes.flexEnd}>
              {handleCancel && (
                <Button
                  disabled={role === "admin" && ownerCode}
                  onClick={handleCancel}
                  color="primary"
                  variant="outlined"
                  className={classes.button}
                >
                  {t("cancel")}
                </Button>
              )}
              <Button
                disabled={role === "admin" && ownerCode}
                onClick={() => this.handleCheck("add")}
                color="primary"
                variant="contained"
                className={classes.button}
              >
                {t("menu_menugroup_editmenugroup_add")}
              </Button>
            </Grid>
          )}
        </Grid>
      </form>
    );
  }
}

EditMenuItem.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  serviceCode: state.user.user.roleId.serviceCode,
  ownerCode: state.service.service.userCode,
  role: state.user.user.roleId.role,
  serviceSetting: state.serviceSetting.serviceSetting,
});

const mapDispatch = (dispatch) => ({
  uploadDispatch: dispatch.upload,
  getMenuGroup: dispatch.serviceMenu.getMenuGroup,
  addMenuGroup: dispatch.serviceMenu.addMenuGroup,
  editMenuGroup: dispatch.serviceMenu.editMenuGroup,
  deleteMenuGroup: dispatch.serviceMenu.deleteMenuGroup,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(textFieldStyles)(EditMenuItem)));
